// Custom hook to use the typed version of useDispatch hook for dispatching actions with TypeScript support.
import { useDispatch } from 'react-redux';
import type { AppDispatch } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
